'use client'

import { useSyncExternalStore } from 'react'
import { ThemeProvider } from '@/components/providers/ThemeProvider'
import DashboardClient from '@/components/dashboard/DashboardClient'

const emptySubscribe = () => () => {}

function useHydrated() {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )
}

export default function Home() {
  const hydrated = useHydrated()

  if (!hydrated) {
    return (
      <div className="min-h-screen" style={{ background: '#070710' }} suppressHydrationWarning />
    )
  }

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      disableTransitionOnChange
    >
      <div suppressHydrationWarning>
        <DashboardClient />
      </div>
    </ThemeProvider>
  )
}
